/**
 * @generated SignedSource<<68c702f7015cf887cde866773ea97892>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CartFragment$data = {
  readonly items: ReadonlyArray<{
    readonly id: string;
    readonly amount: number | null;
    readonly price: number | null;
    readonly product: {
      readonly isVoucher: boolean | null;
      readonly isCertificate: boolean | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"CartItemFragment">;
  } | null> | null;
  readonly fullSum: number | null;
  readonly discounts: {
    readonly discounts: ReadonlyArray<{
      readonly name: string | null;
      readonly discount: number | null;
      readonly discountedSum: number | null;
      readonly discountSum: number | null;
    } | null> | null;
    readonly discount: number | null;
    readonly discountSum: number | null;
  } | null;
  readonly advancePayment: number | null;
  readonly total: number | null;
  readonly auctionMessage: string | null;
  readonly " $fragmentType": "CartFragment";
};
export type CartFragment$key = {
  readonly " $data"?: CartFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CartFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discount",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discountSum",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CartItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "price",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "product",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isVoucher",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isCertificate",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CartItemFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullSum",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Discounts",
      "kind": "LinkedField",
      "name": "discounts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Discount",
          "kind": "LinkedField",
          "name": "discounts",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "discountedSum",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "advancePayment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "auctionMessage",
      "storageKey": null
    }
  ],
  "type": "Cart",
  "abstractKey": null
};
})();

(node as any).hash = "a3bd49871721afc62ab5b21de8a9f268";

export default node;
